module.exports = __webpack_public_path__ + "img/client-12.9e9d9ba1.png";